export const iconFontAwesomeBuildingsToiletPortable = (
	<i className="fa-solid fa-toilet-portable"></i>
);
